import config from '../config';

const getAPIKey = () => {
	const apiKey = config.REACT_APP_GEOCODING_API_KEY;
	return apiKey;
}

const handleGeocodeResponse = (response)=>{
	return response.text().then((text)=>{
		try{
			const json = JSON.parse(text);
			var results = [];
			for (var i = 0; i < json.results.length; i += 1) {
				results.push({
					placeId: json.results[i].place_id,
					formattedAddress: json.results[i].formatted_address,
					location: json.results[i].geometry.location,
					bounds: json.results[i].geometry.viewport,
					types: json.results[i].types,
				})
			}

			return results;
		} catch(e){
			return Promise.reject({ error: response.status, json: {} });
		}
		
	});
}

export default function geocode(searchQuery){
	const url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+ encodeURI(searchQuery) +'&key=' + getAPIKey();
	return fetch(url).then(handleGeocodeResponse);
}



// WEBPACK FOOTER //
// ./src/api/geocode.js